var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-spinner',{staticClass:"mr-2",attrs:{"small":"","label":"กำลังโหลด","variant":"secondary"}}),_c('span',{staticClass:"text-muted"},[_vm._v("กำลังโหลด"+_vm._s(_vm.thing))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }